import { TranslateService } from '@ngx-translate/core';

export const appInitializeTranslationFactory = (
  translateService: TranslateService
): (() => Promise<unknown>) => {
  return () => translateService.use('en').toPromise();
};
